import type { MoneyAutomationCountryFeatureConfig } from './type';

export const moneyAutomationFeatureConfigHU: MoneyAutomationCountryFeatureConfig = {
    roundUpSavings: {
        signingEndpoint: 'netbanking/auth/operation/sign/',
        localStoreProductUri: 'savings-account',
    },
};
